{
  "name": "@unkey/ratelimit",
  "version": "0.5.5",
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "license": "MIT",
  "private": false,
  "publishConfig": {
    "access": "public"
  },
  "keywords": [
    "unkey",
    "ratelimit",
    "global",
    "serverless"
  ],
  "bugs": {
    "url": "https://github.com/unkeyed/unkey/issues"
  },
  "homepage": "https://github.com/unkeyed/unkey#readme",
  "files": [
    "./dist/**",
    "README.md"
  ],
  "author": "Andreas Thomas <andreas@unkey.dev>",
  "scripts": {
    "build": "tsup"
  },
  "devDependencies": {
    "@types/node": "^20.14.9",
    "@unkey/tsconfig": "workspace:^",
    "tsup": "^8.0.2",
    "typescript": "^5.5.3"
  },
  "dependencies": {
    "@unkey/api": "workspace:^"
  }
}
